// About.js
import React from 'react';

const About = () => {
  const skills = [
    { category: 'Frontend', techs: ['React', 'JavaScript', 'CSS', 'HTML'] },
    { category: 'Backend', techs: ['Java', 'Python', 'Node.js', 'SQL'] },
    { category: 'Tools', techs: ['Git', 'VS Code', 'Figma', 'Jupyter'] }
  ];

  const pillars = [
    {
      icon: '🏗️',
      title: 'Full-Stack Engineering',
      body: 'End-to-end experience across React, Node.js, Java, and Python — from designing REST APIs to shipping polished UIs.',
    },
    {
      icon: '📊',
      title: 'Data & Analytics',
      body: 'Applied machine learning and data analysis using Python, Jupyter, and SQL to extract insight from complex datasets.',
    },
    {
      icon: '♿',
      title: 'Accessible by Default',
      body: 'Semantic HTML, keyboard navigation, and WCAG-aware design are part of my standard workflow, not an afterthought.',
    },
    {
      icon: '🤝',
      title: 'Collaborative & Agile',
      body: 'Comfortable in cross-functional teams — experienced with sprint planning, code review, and iterative delivery.',
    },
  ];

  return (
    <div id="about" style={{ 
      padding: '4rem 2rem', 
      background: '#F2EDE4',
      color: '#2C1F14'
    }}>
      <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '3rem', color: '#B5624A' }}>About Me</h2>
      
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Bio Section */}
        <div style={{ 
          background: 'rgba(181, 98, 74, 0.07)',
          borderLeft: '4px solid #B5624A',
          padding: '2rem',
          borderRadius: '0.5rem',
          marginBottom: '3rem'
        }}>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#6B5444', margin: 0 }}>
            I'm Shreya, a passionate web developer based in Canada who loves turning ideas into interactive digital experiences. With expertise in React, JavaScript, and full-stack development, I focus on building applications that are not just functional, but also delightful to use. When I'm not coding, you'll find me baking, exploring new technologies, or playing games.
          </p>
        </div>

        {/* Skills Section */}
        <div style={{ marginBottom: '3rem' }}>
          <h3 style={{ fontSize: '1.8rem', color: '#B5624A', marginBottom: '1.5rem', marginTop: 0 }}>My Tech Stack</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
            {skills.map((skillGroup, idx) => (
              <div key={idx} style={{
                background: '#FFFFFF',
                border: '1px solid rgba(181, 98, 74, 0.2)',
                borderRadius: '1rem',
                padding: '1.5rem',
                boxShadow: '0 4px 20px rgba(44, 31, 20, 0.06)'
              }}>
                <h4 style={{ color: '#B5624A', marginTop: 0, marginBottom: '1rem', fontSize: '1.2rem' }}>{skillGroup.category}</h4>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
                  {skillGroup.techs.map((tech, i) => (
                    <span key={i} style={{
                      background: 'linear-gradient(135deg, #B5624A 0%, #C87B5E 100%)',
                      color: '#fff',
                      padding: '0.5rem 1rem',
                      borderRadius: '1.5rem',
                      fontSize: '0.9rem',
                      fontWeight: '500'
                    }}>
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* What I Bring */}
        <div style={{ marginBottom: '3rem' }}>
          <h3 style={{ fontSize: '1.8rem', color: '#B5624A', marginBottom: '1.5rem', marginTop: 0 }}>What I Bring</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '1.5rem' }}>
            {pillars.map((p, idx) => (
              <div key={idx} style={{
                background: '#FFFFFF',
                border: '1px solid rgba(181, 98, 74, 0.18)',
                borderRadius: '1rem',
                padding: '1.75rem',
                boxShadow: '0 4px 20px rgba(44, 31, 20, 0.06)',
              }}>
                <div style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>{p.icon}</div>
                <h4 style={{ margin: '0 0 0.6rem', color: '#2C1F14', fontSize: '1.05rem', fontWeight: 700 }}>{p.title}</h4>
                <p style={{ margin: 0, color: '#6B5444', fontSize: '0.95rem', lineHeight: 1.65 }}>{p.body}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div style={{
          background: 'rgba(181, 98, 74, 0.07)',
          border: '2px solid rgba(181, 98, 74, 0.2)',
          borderRadius: '1rem',
          padding: '2.5rem',
          textAlign: 'center'
        }}>
          <h3 style={{ fontSize: '1.6rem', color: '#B5624A', marginTop: 0, marginBottom: '1rem' }}>Let's Build Something Amazing!</h3>
          <p style={{ color: '#6B5444', fontSize: '1.1rem', marginBottom: '1.5rem', lineHeight: '1.6' }}>
            I'm always excited to collaborate on interesting projects, discuss new technologies, or help bring your ideas to life. Whether you're looking for a developer, want to chat about tech, or just want to connect - I'd love to hear from you!
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="mailto:m.shreyasharma@gmail.com" style={{
              background: 'linear-gradient(135deg, #B5624A 0%, #C87B5E 100%)',
              color: '#fff',
              padding: '0.9rem 2rem',
              borderRadius: '2rem',
              textDecoration: 'none',
              fontWeight: 'bold',
              transition: 'all 0.3s ease',
              display: 'inline-block',
              boxShadow: '0 4px 15px rgba(181, 98, 74, 0.25)'
            }} className="cta-button">Get in Touch</a>
            <a href="#projects" style={{
              background: 'transparent',
              color: '#B5624A',
              padding: '0.9rem 2rem',
              borderRadius: '2rem',
              textDecoration: 'none',
              fontWeight: 'bold',
              transition: 'all 0.3s ease',
              display: 'inline-block',
              border: '2px solid #B5624A'
            }} className="cta-button">View My Work</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
